<div class="modal-overlay">
  <div class="modal-content">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">
      &times;
    </button>

    <div class="modal-body">
      <div class="modal-header">
        <h2>{{ mode === 'edit' ? ('user.modalEditTitle' | t:'Edit Subuser') : ('user.modalNewTitle' | t:'New Subuser') }}</h2>
      </div>

      <form [formGroup]="employeeForm" (ngSubmit)="onSubmit()">
        <div class="form-grid">
          <div class="form-group">
            <label>{{ 'user.name' | t:'Name' }} *</label>
            <input type="text" formControlName="name" [placeholder]="'placeholder.typeEmployeeName' | t:'Type subuser name'" />
            <div class="field-error" *ngIf="hasError('name', 'required')">Name is required.</div>
          </div>

          <div class="form-group">
            <label>{{ 'user.mobile' | t:'Mobile' }} *</label>
            <div class="mobile-input-wrap">
              <span class="mobile-prefix">{{ mobilePrefix }}</span>
              <input
                type="tel"
                inputmode="numeric"
                formControlName="mobileNumber"
                [placeholder]="'placeholder.typeMobileNumber' | t:'Type mobile number'"
                (blur)="normalizeMobileInput()"
              />
            </div>
            <div class="field-error" *ngIf="hasError('mobileNumber', 'required')">Mobile number is required.</div>
            <div class="field-error" *ngIf="hasError('mobileNumber', 'pattern')">Enter a valid mobile number.</div>
          </div>

          <div class="form-group">
            <label>{{ 'user.email' | t:'Email' }}</label>
            <input type="email" formControlName="email" [placeholder]="'placeholder.typeEmployeeEmail' | t:'Type subuser email'" />
            <div class="field-error" *ngIf="hasError('email', 'email')">Enter a valid email address.</div>
          </div>
        </div>

        <div class="form-message error form-message-block" *ngIf="error">{{ error }}</div>

        <div class="form-actions">
          <button
            *ngIf="mode === 'edit'"
            type="button"
            class="DocumentUpdateBTN"
            (click)="openImageUpdate()"
          >
            {{ 'user.employeeImageUpdate' | t:'Subuser Image Update' }}
          </button>
          <button class="PositiveBTN" type="submit" [disabled]="isSubmitting">
            {{ isSubmitting ? ('common.saving' | t:'Saving...') : (mode === 'edit' ? ('user.updateButton' | t:'Update Subuser') : ('user.addButton' | t:'Add Subuser')) }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
